"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _modalContext = _interopRequireDefault(require("../modal-context"));

var _title = _interopRequireDefault(require("./components/title"));

var _close = _interopRequireDefault(require("./components/close"));

var _back = _interopRequireDefault(require("./components/back"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  padding: ", ";\n  min-height: ", ";\n\n  position: ", ";\n  top: 0;\n  left: 0;\n  z-index: 10;\n\n  display: flex;\n  align-items: flex-start;\n  vertical-align: middle;\n  justify-content: space-between;\n  border-bottom: ", ";\n  background: ", ";\n\n  &.modal-variant-transparent {\n    background: transparent;\n  }\n\n  &.modal-variant-light {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ModalHeaderBase = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.width;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.minHeight;
}, function (props) {
  return props.sticky ? 'sticky' : 'fixed';
}, function (props) {
  return props.bordered ? "1px solid ".concat(props.theme.palette.black.lighter) : '';
}, function (props) {
  return props.theme.palette.lightGray.main;
}, function (props) {
  return props.theme.palette.white.main;
});

var ModalHeader = function ModalHeader(props) {
  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      bodyScroll = _useContext.bodyScroll,
      headerRef = _useContext.headerRef,
      variant = _useContext.variant;

  return _react["default"].createElement(ModalHeaderBase, (0, _extends2["default"])({
    ref: headerRef
  }, (0, _omit["default"])(props, 'children, variant'), {
    className: "modal-variant-".concat(variant),
    sticky: bodyScroll
  }), props.children);
}; // Compound.


ModalHeader.Title = _title["default"];
ModalHeader.Close = _close["default"];
ModalHeader.Back = _back["default"]; // Prop Registration

ModalHeader.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  bordered: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  minHeight: _propTypes["default"].string,
  padding: _propTypes["default"].string
};
ModalHeader.defaultProps = {
  bordered: false,
  width: '100%',
  minHeight: '64px',
  padding: '12px'
};
var _default = ModalHeader;
exports["default"] = _default;